import * as React from 'react';

const SvgStar = (props) => (
  <svg
    width={55}
    height={56}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M40.47 52.452c-1.214 0-2.772-.39-4.72-1.535l-6.852-4.057c-.71-.412-2.086-.412-2.773 0l-6.875 4.057c-4.056 2.406-6.44 1.443-7.517.664-1.054-.779-2.704-2.773-1.627-7.356l1.627-7.035c.184-.734-.183-1.994-.733-2.544l-5.683-5.684c-2.842-2.841-2.613-5.27-2.223-6.462.39-1.192 1.627-3.3 5.568-3.965l7.31-1.214c.688-.115 1.674-.848 1.972-1.467L22 7.764c1.833-3.69 4.24-4.24 5.5-4.24 1.26 0 3.667.55 5.5 4.24l4.033 8.067c.321.619 1.306 1.352 1.994 1.467l7.31 1.214c3.965.665 5.202 2.773 5.57 3.965.366 1.192.595 3.62-2.224 6.462L44 34.646c-.55.55-.894 1.787-.733 2.544l1.627 7.035c1.054 4.583-.573 6.577-1.627 7.356-.573.413-1.49.871-2.796.871Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgStar;
